var map = {
	"./BtoBOrdering.png": 21530,
	"./Chat.png": 14214,
	"./Corporate.png": 79735,
	"./FoodsChannel.png": 28990,
	"./Forum.png": 46603,
	"./MastHub.png": 783,
	"./MenuPlus.png": 79354,
	"./Notification.png": 78455,
	"./ShareFile.png": 17302,
	"./V-Manage.png": 56705
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6312;